module.exports = __webpack_public_path__ + "h5/img/help1.e1894b84.png";